import { createContext, FC, useContext, useState } from 'react';
import * as eligibilityService from 'api/eligibility';
import { IEligibilityContext, IEligibilityProviderProps, IEligibilityResult } from './types';

const EligibilityContext = createContext<IEligibilityContext | null>(null);

const EligibilityProvider: FC<IEligibilityProviderProps> = props => {
  const [loading, setLoading] = useState<boolean>(false);
  const [results, setResults] = useState<IEligibilityResult[]>([]);
  const [applicationId, setApplicationId] = useState<string | null>(null);

  const fetchEligibility = async (id: string) => {
    try {
      setLoading(true);
      const response = await eligibilityService.fetchEligibilityByRefNumber(id);

      if (response.data[0]) {
        setResults(response.data[0].results);
        setApplicationId(response.data[0].applicationId);
        return response.data[0].applicationId;
      }

      setLoading(false);

      return null;
    } catch (error) {
      setLoading(false);
      setResults([]);
    }
  };

  return (
    <EligibilityContext.Provider
      value={{
        loading,
        applicationId,
        results,
        fetchEligibility,
      }}
      {...props}
    />
  );
};

const useEligibility = () => {
  const hookData = useContext(EligibilityContext);
  if (!hookData) throw new Error('Hook used without provider');
  return hookData;
};

export { EligibilityProvider, useEligibility };
